import React, {Component} from "react";
import {AgencyHeader} from "./AgencyHeader";
import {AgencyTabs} from "./AgencyTabs";
import AgencyInfo from "./AgencyInfo";

export class AgencyProfileContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <section className="section-content agency-page agency-profile-page">
                <AgencyHeader/>
                <AgencyTabs activeTab="-fifth"/>
                <div className="section-body h-items">
                    <AgencyInfo/>
                </div>
            </section>
        )
    }
}
